import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'

const cfgForConvert = {
  multiLineParagraph: false,
  customCssClasses: op => {
    if (op.attributes) {
      const attrs = Object.keys(op.attributes)
      const foundColor = attrs.find(
        element => element.indexOf('font-color-') > -1
      )

      return [...attrs, foundColor?.replace('font-', '') || '']
    }

    return ''
  }
}

const useDeltaToHtmlConverter = deltaObject => {
  const converter = new QuillDeltaToHtmlConverter(
    deltaObject.ops,
    cfgForConvert
  )

  converter.renderCustomWith((op, context) => {
    if (op.insert.type === 's3-image') {
      const image = op.insert.value || {}
      const attrs = Object.keys(op.attributes) || []
      const alt = image.alt || 'Broken image link'
      const url = image.url || ''

      return `<img src="${url}" alt="${alt}" class="${attrs.join(' ')}">`
    }

    return ''
  })

  const convertedHtml = converter.convert()
  return convertedHtml
}

export default useDeltaToHtmlConverter
